import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    SaveButton,
    Toolbar,
    ArrayInput,
    SimpleFormIterator,
} from 'react-admin';
import { required } from 'react-admin';
import { Grid, Typography } from '@mui/material';

const CreateToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const SecretsCreate = () => (
    <Create>
        <SimpleForm toolbar={<CreateToolbar />}>
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="name"
                        validate={[required()]}
                        fullWidth
                        helperText="resources.secrets.helpers.name"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput source="description" fullWidth multiline />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="secretString"
                        validate={[required()]}
                        fullWidth
                        multiline
                        minRows={4}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                        Tags
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <ArrayInput source="tags">
                        <SimpleFormIterator inline>
                            <TextInput source="key" label="Key" />
                            <TextInput source="value" label="Value" />
                        </SimpleFormIterator>
                    </ArrayInput>
                </Grid>
            </Grid>
        </SimpleForm>
    </Create>
);

export default SecretsCreate;
